import PropTypes from "prop-types";
import Image from "next/image";
import Link from "../../Link";
import { mwImage } from "../../../lib/common";
import React, { useMemo } from "react";

function normalizeWebinarEdges(data) {
  if (!data) return [];
  if (Array.isArray(data)) {
    return data.map((node) => ({ node }));
  }
  if (Array.isArray(data.edges)) {
    return data.edges;
  }
  return [];
}

const RelatedWebinars = ({ selectedWebinar, data }) => {

  const relatedNodes = useMemo(() => {
    const edges = normalizeWebinarEdges(data);
    if (!edges.length) return [];

    const currentSlug = selectedWebinar?.slug;
    const tagNames = new Set(
      (selectedWebinar?.tags?.edges ?? [])
        .map((e) => e?.node?.name)
        .filter(Boolean)
    );

    const others = edges
      .map((e) => e?.node)
      .filter((n) => n?.slug && n.slug !== currentSlug);

    const scored = others.map((node) => {
      const nodeTags = new Set(
        (node.tags?.edges ?? []).map((e) => e?.node?.name).filter(Boolean)
      );
      let overlap = 0;
      for (const t of tagNames) {
        if (nodeTags.has(t)) overlap++;
      }
      return { node, overlap };
    });

    scored.sort((a, b) => b.overlap - a.overlap);

    const seen = new Set();
    const out = [];
    for (const { node } of scored) {
      if (seen.has(node.slug)) continue;
      seen.add(node.slug);
      out.push(node);
      if (out.length >= 3) break;
    }
    return out;
  }, [data, selectedWebinar?.slug, selectedWebinar?.tags?.edges]);

  if (relatedNodes.length === 0) return null;

  return (
    <div className={"related-blog"}>
      <div className={"container"}>
        <h2>Related Webinars</h2>
        <div className={"d-flex"}>
          {relatedNodes.map((item, index) => (
            <div className={"blog-card"} key={item.slug || index}>
              <Link href={`/webinar/${item.slug}/`} itemProp="url" prefetch={false}>
                <Image
                  src={mwImage(item?.featuredImage?.node?.sourceUrl)}
                  alt={item.title || ""}
                  width={100}
                  height={100}
                  loading="lazy"
                  unoptimized
                />
              </Link>
              <Link href={`/webinar/${item.slug}/`} itemProp="url" prefetch={false}>
                <h4>{item.title}</h4>
              </Link>
              <Link href={`/webinar/${item.slug}/`} className={"read-more"}>
                Watch Now
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

RelatedWebinars.propTypes = {
  selectedWebinar: PropTypes.any,
  data: PropTypes.oneOfType([
    PropTypes.shape({ edges: PropTypes.array }),
    PropTypes.array,
  ]),
};

export default RelatedWebinars;
